import { MaskedLine, FadeIn } from './Reveal';

export default function PageHero({ overline, lines, sub }) {
    return (
        <section className="dark-section relative pt-40 pb-20 sm:pt-48 sm:pb-24 overflow-hidden">
            <div
                className="absolute -top-32 right-0 w-[36rem] h-[36rem] rounded-full pointer-events-none"
                style={{ background: 'radial-gradient(circle, rgba(138,147,245,0.12) 0%, transparent 65%)' }}
            />
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <FadeIn>
                    <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-bronze flex items-center gap-3 mb-8">
                        <span className="inline-block w-10 h-px bg-bronze" />
                        {overline}
                    </p>
                </FadeIn>
                <h1 className="font-serif font-semibold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-cream max-w-4xl">
                    {lines.map((l, i) => (
                        <MaskedLine key={i} delay={0.15 + i * 0.15}>
                            {l}
                        </MaskedLine>
                    ))}
                </h1>
                {sub && (
                    <FadeIn delay={0.6}>
                        <p className="mt-8 max-w-2xl text-base sm:text-lg text-fog leading-relaxed">{sub}</p>
                    </FadeIn>
                )}
            </div>
        </section>
    );
}
